export default __webpack_public_path__ + "static/media/flag-ja.6325d2e0.svg";